import React, {Component} from 'react';
import {SVGIcon} from '@homeaway/react-svg';
import {CHEVRON_RIGHT__24} from '@homeaway/svg-defs';
import './Spotlights.less';

const SpotlightsMenu = (props) => {
    return (
        <div className="spotlights__menu">
            {props.spotlights &&
                props.spotlights.map((spotlight, index) => {
                    return (
                        <button
                            key={spotlight.title}
                            className={`spotlights__menu-item ${props.currentIndex ===
                                index && 'active'}`}
                            onClick={() => {
                                props.handleClick(index);
                            }}
                            style={{
                                // stylelint-disable-next-line
                                backgroundImage: `url("${
                                    spotlight.thumbnailUrl
                                }")`,
                            }}
                        >
                            <span className="sr-only">{spotlight.title}</span>
                        </button>
                    );
                })}
        </div>
    );
};

const SpotlightsContent = (props) => (
    <div className="spotlights__content">
        <div className="spotlights__content__left">
            <h2 className="spotlights__content__title">{props.title}</h2>
            <p className="spotlights__content__subtitle">
                <em
                    dangerouslySetInnerHTML={{
                        __html: props.subTitle,
                    }}
                />
            </p>
            <p
                className="spotlights__content__body"
                dangerouslySetInnerHTML={{
                    __html: props.body,
                }}
            />
        </div>
        <div className="spotlights__next">
            <button
                onClick={props.nextSpotlight}
                className="spotlights__next__button"
            >
                <SVGIcon markup={CHEVRON_RIGHT__24} />
            </button>
        </div>
    </div>
);

export default class TeamSpotlights extends Component {
    state = {
        currentIndex: 0,
    };

    handleClick = (index) => {
        this.setState({
            currentIndex: index,
        });
    };

    nextSpotlight = () => {
        const length = this.props.spotlights.spotlights.length;
        let currentIndex = this.state.currentIndex;
        if (currentIndex === length - 1) {
            this.setState({currentIndex: 0});
            return;
        }
        currentIndex++;
        this.setState({currentIndex});
    };

    render() {
        if (
            !this.props.spotlights ||
            !this.props.spotlights.spotlights.length
        ) {
            return null;
        }

        const {
            spotlights: {spotlights},
            title,
        } = this.props;

        const {imageUrl, ...rest} = spotlights[this.state.currentIndex];

        return (
            <div className="spotlights bg-module-bg-color">
                <div className="spotlights__image">
                    <img src={imageUrl} alt="" />
                </div>
                <div className="spotlights__container">
                    <p>
                        <strong
                            dangerouslySetInnerHTML={{
                                __html: title,
                            }}
                        />
                    </p>

                    <SpotlightsMenu
                        spotlights={spotlights}
                        currentIndex={this.state.currentIndex}
                        handleClick={this.handleClick}
                    />
                    <SpotlightsContent
                        nextSpotlight={this.nextSpotlight}
                        {...rest}
                    />
                </div>
            </div>
        );
    }
}
